/**
 * @author Fernando FH
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class TelemedicineToStartService extends MainService {

    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.TELEMEDICINE_LIST_TO_START_PAGINATION, params);
    }

     static get(params) {
        return this.postSEC(ServiceConstant.COLPOSCOPY_GET_HISTORY, params);
    }

    static add(params) {
        return this.postSEC(ServiceConstant.TELEMEDICINE_SAVE_DIAGNOSIS_FILES, params);
    }

    static saveFilesTelemedicine(params) {
        return this.postSEC(ServiceConstant.TELEMEDICINE_SAVE_FILES, params);
    }

    static pdf(params) {
                    return this.postPDFSEC(ServicePath.TELEMEDICINE_PDF, params);
                }
 
}